// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"b6f22ba3","239":"faa12d64","248":"36b3e8bd","404":"d12dfedd","713":"25cb6c22","946":"94ca2e17"}[chunkId] + ".chunk.js";
};